export default "__VITE_ASSET__BXNe3lJP__";